<template>
  <div>
    <b-alert v-if="mensagem.id" :variant="variantAlert()" :show="verifyView()" :id="mensagem.tipo">
      <b-row align-h="center">
        <b-col class="col-md-8">
          <b-avatar class="mr-2" :src="mensagem.user.url"></b-avatar>
          <strong>
            {{ mensagem.user.name }} - <span style="font-size:11px;">{{ getUserHeader(mensagem.user) }} </span>
          </strong>
        </b-col>
        <b-col class="col-md-4">
          <b-row align-h="center" id="created_at">
            {{ formatarData(mensagem.created_at) }}
          </b-row>
          <b-row align-h="center">
            <b-badge :variant="getStatus == 'CANCELAR' ? 'danger' : 'secondary'">
              {{ getStatus }}
            </b-badge>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="mensagem.tipo == 'SOLUCIONAR' && tipoReembolso && tipoReembolso !== 'null'" class="mt-3">
        <b-col class="text-right">
          <b-badge variant="success">
            Tipo de Reembolso: {{ getTipoReembolso }}
          </b-badge>
        </b-col>
      </b-row>
      <b-row v-if="mensagem.produtos.length > 0" class="mt-3">
        <b-col>
          <b-table borderless no-border-collapse small :items="mensagem.produtos" :fields="colunasTabela" />
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-3">
        <b-col class="ml-3">
          <pre>
              {{ mensagem.mensagem }}
          </pre>
        </b-col>
      </b-row>
      <b-row align-v="center" class="mt-3" v-if="mensagem.arquivos.length > 0">
        <b-col class="col-md-2 text-right">
          <b> Anexos: </b>
        </b-col>
        <div v-for="(arquivo, id) in arquivos" :key="id">
          <b-col class="text-left" v-if="arquivo.path && arquivo.tipo[1] == 'pdf'">
            <a :href="arquivo.url" target="_blank"><i class="fas fa-file-pdf fa-2x"></i></a>
          </b-col>
          <b-col class="text-left" v-else :id="id">
            <a href="#" @click.prevent="verAnexo(arquivo)">
              <b-img thumbnail fluid :src="arquivo.url" v-bind="mainProps" rounded alt="Rounded image" />
            </a>
          </b-col>
        </div>
      </b-row>
      <b-row align-h="center">
        <b-col>
        </b-col>
        <b-col v-if="mensagem.reembolso" class="col-md-4">
          <b-row align-h="center">
            <b-badge :variant="mensagem.reembolso == 'APROVADO' ? 'success' : 'danger'">
              REEMBOLSO {{ mensagem.reembolso }}
            </b-badge>
          </b-row>
        </b-col>
      </b-row>
    </b-alert>
    <b-modal centered ok-title="Fechar" ok-only hide-header size="xl" v-model="modalAnexo">
      <b-row align-h="center" align-v="center">
        <b-img width="650" height="750" :src="arquivoModal.url" fluid></b-img>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Mensagem",
  props: {
    tipoReembolso: {
      type: String,
      default: ""
    },
    mensagem: {
      type: Object,
    },
    perfil: {
      type: String
    }
  },
  data() {
    return {
      colunas: [
        {
          key: "nome",
          label: "Produtos",
          formatter: (value, key, obj) => {
            return obj.codigo ? obj.codigo + " - " + obj.nome : "";
          },
        },
        {
          key: "pivot.quantidade",
          label: "Qtd",
          formatter: (value, key, obj) => {
            return this.mensagem.tipo == 'SOLUCIONAR' && !obj.pivot.reembolsar ? "Reembolso Cancelado" : obj.pivot.quantidade;
          },
        },
        {
          key: "pivot.lote_produto_avaria",
          label: "Lote Avaria",
          formatter: (value) => {
            return value ? value : "-";
          },
        },
      ],
      arquivos: [],
      mainProps: { width: 75, height: 75 },
      modalAnexo: false,
      arquivoModal: { path: "" },
    };
  },
  created() {
    this.arquivos = this.mensagem.arquivos;
  },
  computed: {
    colunasTabela() {
      return this.colunas;
    },
    getTipoReembolso() {
      let tipo = this.tipoReembolso;
      if (this.tipoReembolso == 'PRODUTO-RECLAMADO') {
        tipo = 'PRODUTO'
      }
      return tipo
    },
    getStatus() {
      let status = "NOVO";
      if (this.mensagem.tipo == "PENDENCIAR") status = "PENDÊNCIA";
      if (this.mensagem.tipo == "RESPONDER") status = "RESPOSTA";
      if (this.mensagem.tipo == "SOLUCIONAR") status = "SOLUÇÃO";
      if (this.mensagem.tipo == "COMERCIAL") status = "ENVIADO PARA COMERCIAL";
      if (this.mensagem.tipo == "TRANSPORTE") status = "ENVIADO PARA TRANSPORTE";
      if (this.mensagem.tipo == "QUALIDADE") status = "ENVIADO PARA QUALIDADE";
      if (this.mensagem.tipo == "QUALIDADE_LOGISTICA") status = "ENVIADO PARA QUALIDADE LOGISTICA";
      if (this.mensagem.tipo == "EXPEDICAO") status = "ENVIADO PARA EXPEDICAO";
      if (this.mensagem.tipo == "CANCELAR") status = "CANCELAR";
      return status;
    },
  },
  methods: {
    getUserHeader(user) {
      let funcao = "";
      if (user.distribuidor)
        funcao = "DISTRIBUIDOR";
      else if (user.roles[0].name == "supervisor_expedicao")
        funcao = "SUPERVISOR DE EXPEDIÇÃO";
      else if (user.roles[0].name == "analista_qualidade")
        funcao = "ANALISTA DE QUALIDADE";
      else if (user.roles[0].name == "analista_qualidade_logistica")
        funcao = "ANALISTA DE QUALIDADE LOGISTICA";
      else if (user.roles[0].name == "analista_expedicao")
        funcao = "ANALISTA DE EXPEDIÇÃO";
      else if (user.roles[0].name == "analista_transporte")
        funcao = "ANALISTA DE TRANSPORTE";
      else if (user.roles[0].name == "gestor_qualidade")
        funcao = "GESTOR DE QUALIDADE";
      else if (user.roles[0].name == "gestor_logistica")
        funcao = "GESTOR DE LOGISTICA";
      else if (user.roles[0].name == "supervisor_transporte")
        funcao = "SUPERVISOR DE TRANSPORTE";
      else if (user.roles[0].name == "comercial")
        funcao = "ANALISTA COMERCIAL";
      else if (user.roles[0].name == "coord_comercial")
        funcao = "COORD. COMERCIAL";
      else if (user.roles[0].name == "sac")
        funcao = "SAC";
      return funcao;
    },
    variantAlert() {
      if (this.mensagem.tipo === "NOVO") return "success";
      else if (this.mensagem.tipo === "RESPONDER") return "info";
      else if (this.mensagem.tipo === "PENDENCIAR") return "warning";
      else if (this.mensagem.tipo === "SOLUCIONAR") return "blue";
      else if (this.mensagem.tipo === "FECHADO") return "dark";
      else if (this.mensagem.tipo === "REABRIR") return "danger";
      else return "info";
    },
    verifyView() {
      if (this.perfil == 'distribuidor' && this.mensagem.user.distribuidor) {
        return true;
      } else if (this.perfil == 'distribuidor' && (this.mensagem.tipo == 'NOVO' || this.mensagem.tipo == 'SOLUCIONAR' || this.mensagem.tipo == 'REABRIR' || this.mensagem.tipo == 'PENDENCIAR')) {
        return true;
      } else if (this.perfil != 'distribuidor') {
        return true;
      } else {
        return false;
      }
    },
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
    verAnexo(arquivo) {
      this.arquivoModal = arquivo;
      this.modalAnexo = true;
    },
  },
};
</script>

<style>
#created_at {
  font-size: 10px;
}

b-alert {
  max-width: 100%;
  overflow-x: hidden;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin: 0;
  padding: 0;
  font-family: "Helvetica", sans-serif;
}

#imagem {
  max-width: 40%;
  max-height: 40%;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ocorrencia/componente/Mensagem.vue